import { createWebHistory, createRouter } from "vue-router";

import HomePage from "../pages/Home/HomePage.vue";
import RealtimePage from "../pages/Realtime/RealtimePage.vue";
import RecordingsPage from "../pages/Recordings/RecordingsPage.vue";
import CamMapPage from "../pages/CamMap/CamMapPage.vue";
import PricesPage from "../pages/Prices/PricesPage.vue";
import ParkingPage from "../pages/Parking/ParkingPage.vue";
import ParkingPaymentPage from "../pages/Parking/ParkingPaymentPage.vue";
import LoginPage from "../pages/Authentication/LoginPage.vue";
import RegisterPage from "../pages/Authentication/RegisterPage.vue";
import ForgotPasswordPage from "../pages/Authentication/ForgotPasswordPage.vue";
import ForgotPasswordSendEmailPage from "../pages/Authentication/ForgotPasswordSendEmailPage.vue";
import TermsPage from "../pages/TermsPage.vue";
import ErrorPage from "../pages/ErrorPage.vue";
import CompaniesPage from "../pages/Companies/CompaniesPage.vue";
import UserListPage from "../pages/UserList/UserListPage.vue";

const routes = [
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
  },
  {
    path: "/realtime",
    name: "RealtimePage",
    component: RealtimePage,
  },
  {
    path: "/recordings",
    name: "RecordingsPage",
    component: RecordingsPage,
  },
  {
    path: "/downloads",
    name: "DownloadsPage",
    component: () => import("../pages/Downloads/DownloadsPage.vue"),
  },
  {
    path: "/cam-map",
    name: "CamMapPage",
    component: CamMapPage,
  },
  {
    path: "/payment",
    name: "PaymentPage",
    component: () => import("../pages/Payment/PaymentPage.vue"),
  },
  {
    path: "/prices",
    name: "PricesPage",
    component: PricesPage,
  },
  {
    path: "/parking/payment",
    name: "ParkingPaymentPage",
    component: ParkingPaymentPage,
    meta: { public: true },
  },
  {
    path: "/parking",
    name: "ParkingPage",
    component: ParkingPage,
  },
  {
    path: "/installation",
    name: "CompaniesPage",
    component: CompaniesPage,
  },
  {
    path: "/installation/:installation_id",
    name: "UserListPage",
    component: UserListPage,
  },
  {
    path: "/login",
    name: "LoginPage",
    component: LoginPage,
  },
  {
    path: "/register",
    name: "RegisterPage",
    component: RegisterPage,
  },
  {
    path: "/forgot-password",
    name: "ForgotPasswordPage",
    component: ForgotPasswordPage,
  },
  {
    path: "/send-email-forgot-password",
    name: "ForgotPasswordSendEmailPage",
    component: ForgotPasswordSendEmailPage,
  },
  {
    path: "/terms",
    name: "TermsPage",
    component: TermsPage,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "ErrorPage",
    component: ErrorPage
  }
];

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: "active",
  routes: routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

export default router;
